import { AlertCircle } from 'react-feather'
import { Button, Modal, ModalBody, Spinner } from 'reactstrap'

const ModalConfirmClose = ({
  isOpen,
  toggle,
  projectLabel,
  onClose,
  isLoading,
  errMsg,
  isDisabling,
}) => {
  const handleSubmit = (e) => {
    e.preventDefault()
    if (onClose) {
      onClose()
    }
  }

  return (
    <Modal
      className="p-4"
      centered
      isOpen={isOpen}
      toggle={toggle}
      autoFocus={false}
      data-testid="project-modal-close"
    >
      <ModalBody>
        <h5>Tutup Project</h5>
        <p className="text-muted">
          Anda yakin ingin menutup project{' '}
          {projectLabel ? <strong>{projectLabel}</strong> : 'ini'}?
        </p>

        {errMsg && (
          <small className="text-danger">
            <AlertCircle size={15} /> {errMsg}
          </small>
        )}
        <div className="d-flex gap-3">
          <Button
            onClick={toggle}
            disabled={isLoading}
            color="secondary"
            outline
            block
            className="btn-cancel"
            data-testid="project-modal-close-cancel-button"
          >
            Batal
          </Button>
          <Button
            disabled={isLoading || isDisabling}
            onClick={handleSubmit}
            block
            color="primary"
            data-testid="project-modal-close-submit-button"
          >
            {(isLoading || isDisabling) && (
              <Spinner size="sm" className="me-2" />
            )}
            Tutup
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ModalConfirmClose
